<template>
  <div>
    <div class="custom-select" style="width: 100%;">
      <input v-enter-to-tab :key=localKey :type=type :value=inputValue
        ref="input"
             :class="`${styles} ${navigableWithEnter ? 'EnterToTab' : ''}`"
             :required=isRequired :readonly=isReadonly :disabled=isDisabled
             @blur="$emit('blur', $event)" @change="$emit('change', $event)" @click="$emit('click', $event)"
             @keydown="$emit('keydown', $event)" />
      <smtt-icon v-if="icon" :icon="icon" class="icon" />
    </div>
    <div class="d-flex" v-if="isInvalid">
      <smtt-icon icon="info-circle" color="#831f1f"  class="mr-2"/>
      <span class="error-label">
        {{ $t('surveyQuestionScreen.openAnswerOption.errorMsgValidation') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppInput",
  props: {
    'type': { 'type': String, 'required': true, 'default': 'text' },
    'inputClass': { 'type': String, 'required': false, 'default': '' },
    'isRequired': { 'type': Boolean, 'required': false, 'default': true },
    'inputValue': { 'type': String, 'required': false },
    'isReadonly': { 'type': Boolean, 'required': false, 'default': false },
    'isDisabled': { 'type': Boolean, 'required': false, 'default': false },
    'navigableWithEnter': { 'type': Boolean, 'required': false, 'default': true },
    'icon': { 'type': String, 'required': false, 'default': '', },
    'isInvalid': { 'type': Boolean, 'required': false, 'default': false },
  },
  watch: {
    'isInvalid': function (newValue) {
      if (newValue) {
        this.$refs.input.classList.add('input-invalid');
      } else {
        this.$refs.input.classList.remove('input-invalid');
      }
    }
  },
  computed: {
    styles() {
      return this.inputClass ? this.inputClass : 'input-field open-answer-option-input'
    }
  },
  data() {
    return {
      'localKey': 0,
    }
  }
}
</script>

<style scoped>
.open-answer-option-input {
  font-size: 1rem !important;
}

.numeric-input {
  text-align: right;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}

.custom-select {
  position: relative;
  display: inline-block;
}

.input-field {
  border: 1px solid #4c4d57;
  border-radius: 0.2rem;
  height: 40px;
  width: 100%;
  padding: 0.375rem 0.75rem;
  color: #495057;
}

.input-field:focus {
  box-shadow: 0 0 1px 2px #006FFF;
  outline: 0;
}

.icon {
  position: absolute;
  right: 0;
  padding: 8px;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.icon:hover {
  background-color: #d2d2d2;
  border-top: 1px solid #4c4d57;
  border-right: 1px solid #4c4d57;
  border-bottom: 1px solid #4c4d57;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  padding: 7px
}

.input-invalid {
  border-color: #831f1f;
}

.error-label {
  color: #831f1f;
}

</style>